export const isMobile = window.innerWidth <= 768
